const newBold = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5 9.1l2.4-4.2h3L8.42 7.3H11l-5.1 4.8 1.2-3z" clip-rule="evenodd"/></svg>',
};

export { newBold as default };
